import React, { useState, useEffect } from "react";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import styles from "./SubMapping.module.css";
import { getPayableMappingCurrency, getFixedAssetSubmappingCurrency } from "../../../../Bookclosure/Services/ApiHandler";

export default function Currency({ PayableID, FixedAssetID, onMappingChange }) {
  const [columnOptions, setColumnOptions] = useState([]);
  const [currencyFields, setCurrencyFields] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});

  const handleFieldChange = (fieldId, value) => {
    setSelectedValues((prev) => {
      const updated = { ...prev, [fieldId]: value };
      onMappingChange(updated); 
      return updated;
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const id = PayableID || FixedAssetID;
        const fetchFunction = PayableID ? getPayableMappingCurrency : getFixedAssetSubmappingCurrency;
        const res = await fetchFunction(id);

        const { fields, labelList } = res.data;
        const transformedFields = (fields || []).flatMap((currency) => [
          {
            id: currency.toLowerCase(),
            label: currency,
            type: "dropdown",
          },
          {
            id: `closingRate${currency}`,
            label: "Closing Rate",
            type: "input",
            placeholder: "Enter Values",
          },
        ]);

        setColumnOptions(labelList || []);
        setCurrencyFields(transformedFields);

        const initialState = {};
        transformedFields.forEach((f) => {
          initialState[f.id] = "";
        });

        setSelectedValues(initialState);
        onMappingChange(initialState);

      } catch (err) {
        console.error("GET Payable Currency error:", err);
      }
    };

    fetchData();
  }, [PayableID, FixedAssetID]);

  return (
    <div className={styles.formGroupGrid}>
      {currencyFields.map((field) =>
        field.type === "dropdown" ? (
          <CustomDropdown
            key={field.id}
            label={field.label}
            value={selectedValues[field.id] || ""}
            onChange={(value) => handleFieldChange(field.id, value)}
            options={columnOptions}
            placeholder="Map Column"
            height="35px"
          />
        ) : (
          <div key={field.id} className={styles.inputField}>
            <label className={styles.inputLabel}>{field.label}</label>
            <input
              type="text"
              className={styles.textInput}
              placeholder={field.placeholder}
              value={selectedValues[field.id] || ""}
              onChange={(e) =>
                handleFieldChange(field.id, e.target.value)
              }
            />
          </div>
        )
      )}
    </div>
  );
}